<template>
  <div class="container">
    <Head :is-show-phone="true" :isShow="true" ></Head>
    <div class="course-box" v-if="courseDataList.length > 0">
      <div class="header-name">我的课程</div>
      <div class="course-list">
        <CourseItem
          :course-data="item"
          :is-show-process="true"
          :isRecommend="false"
          :key="'a'+index"
          v-for="(item,index) in courseDataList"
        ></CourseItem>
      </div>
    </div>
    <div class="course-box" v-if="recommendCourseDataList.length > 0">
      <div class="header-name">推荐课程</div>
      <div class="course-list">
        <CourseItem
          :course-data="item"
          :is-show-process="false"
          :isRecommend="true"
          :key="'b'+index"
          v-for="(item,index) in recommendCourseDataList"
        ></CourseItem>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/pc/Head'
import CourseItem from '@/components/pc/myCourse/CourseItem'
import * as INFO_API from '@/api/ChannelCustomerCourseAPI'
import * as CHANNEL_API from '@/api/ChannelAPI'
export default {
  name: 'myInfo',
  data () {
    return {
      courseDataList: [],
      recommendCourseDataList: [],
      tourist : localStorage.getItem('tourist')  || sessionStorage.getItem('tourist')
    }
  },
  components: {
    CourseItem,
    Head
  },
  mounted () {
    // 初始化数据的接口
       this.MyCourse()
  },
  methods: {

    MyCourse () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
  if(this.tourist == 'true'){
      loading.close();
    if (this.$route.params) {
      this.recommendCourseDataList = this.$route.params.recommendCourseList
    } else {
      this.recommendCourseDataList = JSON.parse(sessionStorage.getItem('channelLogin')).recommendCourseList
    }
    if(this.recommendCourseDataList == null){
       let data = {
        tourist: true,
      }
    CHANNEL_API.ChannelLOgin(data)
        .then(res => {
          if (res.code === 0) {
               this.recommendCourseDataList= res.data.recommendCourseList
          } else {
            console.log(res)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
   }else{
      let data = {
        loginName: localStorage.getItem('shangke_username'),
      }
      INFO_API.MyCourse(data).then(res => {
        loading.close();
          this.courseDataList = res.data.courseEntityList,
          this.recommendCourseDataList = res.data.recommendCourseList
      }).catch(err => {
        loading.close();
        console.log(err)
      })

   }



    },

   
  },
}
</script>
<style lang="less" scoped>
.course-box {
  margin: 30px auto;
  padding: 30px 40px;
  max-width: 1282px;
  background: #ffffff;
  border-radius: 10px;
  .header-name {
    font-size: 24px;
    font-weight: bold;
    color: rgba(26, 26, 26, 1);
    line-height: 64px;
  }
  .course-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>